import React, { useState } from 'react';
import { X } from 'lucide-react';
import { markRPRevoked } from '../../../services/lvWorkPermitFlowService';

interface RPRevokeModalProps {
  isOpen: boolean;
  onClose: () => void;
  permitId: number;
  onSuccess?: () => void;
}

const RPRevokeModal: React.FC<RPRevokeModalProps> = ({ isOpen, onClose, permitId, onSuccess }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    try {
      setLoading(true);

      await markRPRevoked(permitId);

      onSuccess?.();
      onClose();
    } catch (error) {
      console.error('Error revoking suspension:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white w-[420px] rounded-xl shadow-xl p-6 relative">
        <button onClick={onClose} disabled={loading} className="absolute top-3 right-3 text-gray-500 hover:text-gray-800">
          <X size={20} />
        </button>

        <h2 className="text-lg font-semibold mb-4">Revoke Suspension</h2>

        <p className="text-gray-600 mb-6">Are you sure you want to revoke the suspension?</p>

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            disabled={loading}
            className="px-5 py-2 border border-gray-300 rounded-md text-gray-600 hover:bg-gray-100"
          >
            Cancel
          </button>

          <button onClick={handleConfirm} disabled={loading} className="px-5 py-2 bg-red-500 hover:bg-red-600 text-white rounded-md">
            {loading ? 'Processing...' : 'Yes'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RPRevokeModal;
